import {
  API_ENDPOINT,
  useClientApiV1AuthWithdrawCreateMutation,
} from '../../resources/@types/accountSchema';

function useClientAuthWithdrawCreateMutation(
  options?: Parameters<typeof useClientApiV1AuthWithdrawCreateMutation>[0]['options'],
) {
  return useClientApiV1AuthWithdrawCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_AUTH_WITHDRAW,
    options,
  });
}

export default useClientAuthWithdrawCreateMutation;
